import React from "react";

const TemplateSetter = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>Template Setter</h2>

      {/* Iframe to display the external page */}
      <iframe
        src="https://data.livauto.com/email-spam-remover/"
        title="Email Spam Remover"
        width="100%"
        height="800"
        style={{
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      ></iframe>
    </div>
  );
};

export default TemplateSetter;
